module.exports = __webpack_public_path__ + "media/application/images/2018/2018-logo-55913bff93f0ed8db69c18a18b63c51b.svg";